/* eslint-disable lines-between-class-members,dot-notation */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Product } from "../Products";
import { entityTypes, entityTypesTitles, propertyViews, propertyViewTypes } from "./enums";
import { Property } from "./Property";
/**
 * PropertyEntity class
 */

export class PropertyEntity extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getType = (asLabel = false) => {
      return asLabel ? PropertyEntity.entityTypesTitles[this.model.type || 'unknown'] || PropertyEntity.entityTypesTitles['unknown'] : this.model.type;
    };

    this.getEntityId = () => {
      return this.model.entityId;
    };

    this.getPropertyId = () => {
      return this.model.propertyId;
    };

    this.getGroupId = () => {
      return this.model.groupId;
    };

    this.getViewType = (asLabel = false) => {
      return asLabel ? PropertyEntity.propertyViews[this.model.viewType || 'unknown'] || PropertyEntity.propertyViews['unknown'] : this.model.viewType;
    };

    this.getViewValue = () => {
      return this.model.viewValue;
    };

    this.getProperty = property => {
      return this.getRelation('property', Property, property);
    };

    this.getProduct = product => {
      return this.getRelation('product', Product, product);
    };
  }

  /**
   * Create propertyEntity
   *
   * @param {object} object
   *
   * @return {PropertyEntity}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list propertyEntities
   *
   * @param {object} objects
   *
   * @return {Array.<PropertyEntity>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map propertyEntities
   *
   * @param {Array.<object>} objects
   * @param {function(PropertyEntity): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * @inheritDoc
   */


  primaryKey() {
    return `${this.model.type},${this.model.entityId},${this.model.propertyId}`;
  }
  /**
   * Get propertyEntity type
   *
   * @param {boolean} asLabel
   *
   * @return {string}
   */


}
PropertyEntity.propertyViewTypes = propertyViewTypes;
PropertyEntity.propertyViews = propertyViews;
PropertyEntity.entityTypes = entityTypes;
PropertyEntity.entityTypesTitles = entityTypesTitles;